import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ChevronLeft, ChevronRight } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import BackButton from '../components/BackButton';
import StartSidebar from '../components/StartSidebar';

const TEMPLATE_URL = 'https://www.canva.com/design/DAGOhSdFsKc/bQ2RekeNuiH4i44dohSgGQ/view?utm_content=DAGOhSdFsKc&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview';
const TOTAL_PAGES = 2;

const getPageTitle = (page) => {
  const titles = {
    1: 'Referral Program Overview',
    2: 'Referral Program Details'
  };
  return titles[page] || '';
};

const StartPartnerPrograms = () => {
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  const [currentPage, setCurrentPage] = useState(1);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  const handleNextPage = () => {
    if (currentPage < TOTAL_PAGES) setCurrentPage((p) => p + 1);
  };

  return (
    <div className="min-h-screen">
      <StartSidebar />
      <div className="min-h-screen p-6">
        <div className="max-w-7xl mx-auto">
          <div className="rounded-lg p-6">
            <div className="flex items-center justify-between mb-8">
              <BackButton onClick={() => navigate('/start/sales')} />
              <div className="flex items-center">
                <Users className={`text-4xl mr-3 ${darkMode ? 'text-red-400' : 'text-red-600'}`} />
                <h1 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Partner Programs</h1>
              </div>
              <div className="w-[120px]" />
            </div>

            {/* Referrals tab content from Sales / Sales-Referral-Programs */}
            <div>
              {/* Download the template */}
              <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-sm mb-6 ${darkMode ? 'shadow-gray-900' : ''}`}>
                <div className="flex justify-center py-3">
                  <a
                    href={TEMPLATE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm text-white bg-red-600 hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-700 rounded-full px-4 py-2 transition-colors"
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    Download the template
                  </a>
                </div>
              </div>

              {/* Previous / Page X of 2 / Next */}
              <div className="flex items-center justify-between mb-6">
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    currentPage === 1
                      ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
                      : 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
                  }`}
                >
                  <ChevronLeft className="w-5 h-5 mr-2" />
                  Previous
                </button>
                <span className={`text-sm font-medium ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  Page {currentPage} of {TOTAL_PAGES}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === TOTAL_PAGES}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    currentPage === TOTAL_PAGES
                      ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
                      : 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
                  }`}
                >
                  Next
                  <ChevronRight className="w-5 h-5 ml-2" />
                </button>
              </div>

              {/* Referral Program Overview / page content */}
              <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md dark:shadow-gray-900 p-8`}>
                <div className="max-w-3xl mx-auto">
                  <h2 className={`text-2xl font-bold mb-6 text-center ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                    {getPageTitle(currentPage)}
                  </h2>
                  <div className="space-y-6">
                    <div className="space-y-4">
                      <div className={`w-full h-[800px] border rounded-lg overflow-hidden ${darkMode ? 'border-gray-600' : 'border-gray-300'}`}>
                        <iframe
                          src={`/ref-program-pg${currentPage}.pdf#toolbar=0&navpanes=0&scrollbar=0`}
                          className="w-full h-full"
                          title={`PDF Viewer - ${getPageTitle(currentPage)}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPartnerPrograms;

